import { WebPortalService } from '../resource'

const VoiceMailModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    }
  },
  actions: {
    clearData ({ commit, state } ) {
          commit('SET_DATA', [])
    },
    syncData ({ commit, state }, params) {
        return WebPortalService.VoicemailSync(params)
    },
    async listData ({ commit, state },params) {
      try{

      
        const data = await WebPortalService.VoicemailList(params)
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch
      {
        commit('SET_DATA', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    }
  }
}

export default VoiceMailModule